import { useTheme, Box, InputBase } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { SearchRequest, useConfig } from '../../api/api';
import { tokens } from '../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import Cookies from 'universal-cookie';
import { searchResultMap } from '../exo/search/searchResultsMap';

const DBMultiSearch = ({
  params,
  onSearch,
  noInitialLoad,
  sort = null,
  children,
  limit = 25,
  sx,
  value,
  hideSearchBar,
  className,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const config = useConfig();

  const scrollContainerRef = useRef(null);

  const cookies = new Cookies();
  const prefix = cookies.get('searchPrefix');

  const [search, setSearch] = useState('');
  const [searchOffset, setSearchOffset] = useState(0);
  const [hits, setHits] = useState([]);

  useEffect(() => {
    if (!noInitialLoad) handleSearch({ target: { value: value || '' } });
  }, [config, value]);

  function handleSearch(event, newPage, keepHits = false) {
    if (!config) return;
    var searchQueries = [];

    const allowedIndexes = cookies.get('searchIndexes');

    params.forEach((param) => {
      const indexUid = prefix + param;
      if (allowedIndexes.includes(indexUid))
        searchQueries.push({
          indexUid,
          q: event ? event.target.value : search,
          showRankingScore: true,
        });
    });

    const searchData = {
      queries: searchQueries,
    };

    SearchRequest({
      baseUrl: config.searchUrl,
      path: `multi-search`,
      method: 'post',
      data: searchData,
      onResponse: (res) => {
        const query = event ? event.target.value : search;
        console.log(query);

        prepairHits(res, keepHits, query);
        setSearchOffset(searchOffset + limit);
      },
    });
    if (event) setSearch(event.target.value);
  }

  function prepairHits(res, keepHits, query) {
    if (!res) return;
    const { results } = res;
    var totalHitsList = [];
    // get group
    results.forEach((result) => {
      const key = result.indexUid.replace(prefix, '');
      const resultsInfo = searchResultMap[key];

      // add hits with additional infos
      result.hits?.forEach((element) => {
        totalHitsList.push({
          ...element,
          type: resultsInfo.label,
          Icon: resultsInfo.Icon,
          to: resultsInfo.to,
          path: resultsInfo.path,
        });
      });
    });

    if (query?.trim()) {
      // sort hits by relevance score (highest first)
      totalHitsList.sort(
        (a, b) => (b._rankingScore || 0) - (a._rankingScore || 0),
      );
    } else {
      // sort hits alphabetically when no search term is given
      totalHitsList.sort((a, b) =>
        a.label.toUpperCase().localeCompare(b.label.toUpperCase()),
      );
    }

    onSearch(keepHits ? [...hits, ...totalHitsList] : totalHitsList);
    setHits(keepHits ? [...hits, ...totalHitsList] : totalHitsList);
  }

  return (
    <Box
      ref={scrollContainerRef}
      sx={sx}
      className={
        'relative flex flex-col gap-2 h-full w-full overflow-y-auto pr-2 overflow-x-hidden'
      }
    >
      {!hideSearchBar && (
        <Box
          className="flex backdrop-blur-lg py-1 sticky top-0 z-10"
          borderRadius="3px"
          backgroundColor={colors.bgInput}
        >
          <InputBase
            sx={{ ml: 2, flex: 1 }}
            placeholder={t('Search')}
            value={search}
            onChange={handleSearch}
            className="w-full"
          />
        </Box>
      )}
      {children}
    </Box>
  );
};

export default DBMultiSearch;
